<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { logoutAction } from '@/api/functions/auth/logout.action'
import { useMutationApi } from '@/composables/useApi'
import { clearAuth } from '@/composables/useAuth'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'
import ChevronDown from '/svg/chevron-down.svg'

//  Dropdown and modal states
const isOpen = ref(false)
const router = useRouter()
const route = useRoute()
const toast = useToast()
const dropdownRef = ref<HTMLElement | null>(null)

const handleClickOutside = (e: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target as Node)) {
    isOpen.value = false
  }
}

const { mutate: logoutMutate } = useMutationApi({
  mutationKey: ['logout'],
  mutationFn: logoutAction,
  onSuccess: () => {
    clearAuth()
    router.push('/auth/login')
  },
  onError: (err: unknown) => {
    toast.error(getErrorMessage(err), 'خطا')
  },
})

//  Logout handler
const onLogoutClick = () => {
  logoutMutate()
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
  <!-- 👉 Navbar container -->
  <div class="fixed top-0 inset-x-0 bg-[#f5f7fa] h-20 custom-padding z-50">
    <div class="h-full flex items-center justify-between">
      <router-link to="/">
        <img width="97" height="52" class="me-4" src="/item-logo-text.91a2263.svg" />
      </router-link>
      <div class="flex items-center justify-end me-1">
        <!-- 👉 Logout -->
        <div class="relative ms-2 lg:ms-0" @click="isOpen = !isOpen" ref="dropdownRef">
          <div
            class="px-1 cursor-pointer text-[#1b325a ] text-base font-medium flex items-center justify-center gap-1 ">

            <img :src="ChevronDown" width="22" alt="chevron" class="me-1"
              :class="['transition-transform duration-300', isOpen ? 'rotate-180' : 'rotate-0']" />
            ادمین پی‌جیب
            <img src="/svg/emoji.svg" width="22" alt="emoji" />
          </div>
          <!-- Dropdown Menu -->
          <Transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-3"
            enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-3">
            <div v-if="isOpen" class="flex justify-center absolute top-8  w-full pt-[5px]">
              <div
                class="w-full flex items-center gap-4 p-4 z-10 bg-white border py-4 h-full rounded-2xl border-[#2d5396]">
                <button @click="onLogoutClick"
                  class="w-full flex items-center justify-between text-[#000000de] cursor-pointer text-[15px]">
                  خروج
                  <img width="20" height="20" src="/svg/power-icon.svg" />
                </button>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>
